import { ITagAssociationType } from "../../common/models/ITagAssociationType";
import { DefaultTagAssociationTypeEnum, IObjectDefaultsModel } from "../../services/defaults-data-service/Models";
import { CheckListItemType } from "../check-list/CheckList";

const ObjectDefaultUtls = {
    getDefaultItems(data: IObjectDefaultsModel | undefined): Array<CheckListItemType> {
        function buildItem(tat: ITagAssociationType, mode: DefaultTagAssociationTypeEnum): CheckListItemType {
            const equatableKey = `${mode as number}:${tat.id}`;

            return {
                key: equatableKey,
                displayText: tat.name,
                checked: data?.defaults.find(o => o.defaultType === mode && o.tagAssociationTypeID === tat.id) !== undefined
            } as CheckListItemType;
        }

        const graphingItems = data?.tagAssociationTypes
            ?.filter(tat => tat.trendable === true)
            ?.map(tat => buildItem(tat, DefaultTagAssociationTypeEnum.Graph))
            ?? [];

        const mappingItems = data?.tagAssociationTypes
            ?.map(tat => buildItem(tat, DefaultTagAssociationTypeEnum.Mapping))
            ?? [];

        return graphingItems.concat(mappingItems);
    },
}

export default ObjectDefaultUtls;